import React from 'react';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { DownloadButtons } from '../../components/empty/download-buttons';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseContainerBackgroundImage } from '../../utils/manager/layout-manager';

const siteUrl = 'http://menur.app';

function EmptyQRCodeSecondScreen({ onAppDownloadClick }) {
  const { showingModal } = useStorage();
  const { t } = useTranslation();
  const classes = useStyles();

  const goToSiteClick = () => {
    // eslint-disable-next-line no-undef
    window.location.href = siteUrl;
  };

  return (
    <div className={classes.container}>
      {/* <div>&nbsp;</div>
      <div> O que é o Menur</div>
      <div> - Vídeo explicativo</div> */}
      <div>&nbsp;</div>
      <DownloadButtons
        shakeEnabled={!showingModal}
        onAppDownloadClick={onAppDownloadClick}
      />
      <div className={classes.footerContainer}>
        <span>
          {t('empty-qrcode-second.or-access')}
          <Button
            variant="link"
            onClick={goToSiteClick}
            className={classes.link}
          >
            {siteUrl}
          </Button>
        </span>
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    backgroundColor: layoutDefaults.primaryColor,
    backgroundImage: parseContainerBackgroundImage(null, { lighthenOffset: 4 }),

    paddingLeft: layoutDefaults.biggerHorizontalMargin,
    paddingRight: layoutDefaults.biggerHorizontalMargin,
    // backgroundImage: `url(https://cdn.sstatic.net/Img/teams/teams-illo-free-sidebar-promo.svg?v=47faa659a05e)`,
  },
  footerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    marginTop: layoutDefaults.verticalMargin,
    marginBottom: layoutDefaults.biggerVerticalMargin,
  },
  link: {
    cursor: 'pointer',
    color: layoutDefaults.secondaryColor,
  },
});

export { EmptyQRCodeSecondScreen };
